<template>
  <div class="container-sm pb-5">
    <cargador ref="cargador" class="cargador__form-comercio">
      <formulario-comercio
        ref="formulario"
        :hideMinimumDiscount="true"
        :disableSocialNetworks="true"
        :esAdmin="false"
        class="mt-4"
      />
      <boton-guardar
        ref="botonGuardar"
        @click="clickGuardar()"
        class="float-start"
      />
    </cargador>
  </div>
</template>
<script>
import BotonGuardar from "../util/BotonGuardar.vue";
import Cargador from "../util/Cargador.vue";
import { ComercioFacade as Facade } from "../../service/comerciante/comercio/comercio.facade";
import FormularioComercio from "../panel/formularios/FormularioComercio.vue";

export default {
  components: { FormularioComercio, BotonGuardar, Cargador },
  created() {
    Facade.getMine().then((response) => {
      this.$refs.formulario.copiar(response.data);
      this.$refs.cargador.parar();
    });
  },
  methods: {
    clickGuardar() {
      if (this.$refs.formulario.esValido()) {
        Facade.update(this.$refs.formulario.dto())
          .then(() => {
            this.$refs.formulario.limpiarFeedback();
          })
          .catch(() => this.$refs.botonGuardar.feedbackError());
      } else {
        this.$refs.formulario.mostrarFeedback();
        this.$refs.botonGuardar.feedbackDatosFaltantes();
      }
    },
  },
};
</script>
<style lang="scss">
.cargador__form-comercio > div {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
